import { Box, Typography, Accordion, AccordionSummary, AccordionDetails, Link } from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';

const Infographic = () => {
  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
      <Box>
        <Typography variant="h5" component="h5">
          CHARR Guides
        </Typography>
      </Box>
      <Box>
        <Accordion>
          <AccordionSummary
            expandIcon={<ExpandMoreIcon />}
            aria-controls="panel1a-content"
            id="panel1a-header"
          >
            <Typography variant="h7" component="div">Metric User Guide</Typography>
          </AccordionSummary>
          <AccordionDetails>
            <Link
              href="https://ikhala-static-content1.s3.eu-central-1.amazonaws.com/user-guides/METRIC_User+Guide+%26+Mock-Up+Data.pdf"
              target="_blank" rel="noopener"
              sx={{ mt: 2, display: 'block' }}>
              View Documentation
            </Link>
          </AccordionDetails>
        </Accordion>

        <Accordion >
          <AccordionSummary
            expandIcon={<ExpandMoreIcon />}
            aria-controls="panel2a-content"
            id="panel2a-header"
          >
            <Typography variant="h7" component="div">Imperial User Guide</Typography>
          </AccordionSummary>
          <AccordionDetails>
            <Link
              href="https://ikhala-static-content1.s3.eu-central-1.amazonaws.com/user-guides/IMPERIAL_User+Guide+%26+Mock-Up+Data.pdf"
              target="_blank" rel="noopener"
              sx={{ mt: 2, display: 'block' }}>
              View Documentation
            </Link>
          </AccordionDetails>
        </Accordion>
      </Box>
    </Box>
  );
};

export default Infographic;
